<template>
  <v-layout column>
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        v-if="editedItem !== null"
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0; overflow: visible"
      >
        <input-field
          :label="familyId === 'ac' ? $tc('Accessory', 1) : $tc('Other', 1)"
          :value="editedItem.sm_quantity"
          input-type="other"
          size="100"
          :required="true"
          :field-disabled="editing"
        >
          <treeselect
            :value="editedItem.sm_id"
            @input="updateValue"
            :options="accessoriesOptions"
            :load-options="loadAccessoriesOptions"
            :normalizer="accessoriesOptionsNormalizer"
            :searchable="false"
            :disabled="editing"
          />
        </input-field>

        <input-field
          :label="$t('Quantity')"
          v-model="editedItem.quantity"
          input-type="number"
          :min="0"
          size="100"
          :required="true"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="close"
        />
        <management-button
          type="execute"
          :label="editing ? $t('ApplyChanges') : $t('Add')"
          :disabled="!requiredAreFilled"
          @buttonClick="applyChanges"
        />
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import ManagementButton from "@/components/Management/ManagementButton";
import { mapActions } from "vuex";
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import _ from "lodash";
export default {
  name: "AccessoriesAndOthersForm",
  components: { InputField, ManagementButton },
  props: {
    originalItem: {
      type: Object,
      required: true
    },

    familyId: {
      type: String,
      required: true
    },

    relationFamilyIdSelect: String,

    selectedFields: {
      type: Array,
      required: true
    },

    currentAction: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      accessoriesOptions: null,

      editedItem: {}
    };
  },

  computed: {
    requiredAreFilled() {
      return this.editedItem.sm_id && this.editedItem.quantity;
    },

    editing() {
      return this.currentAction === "edit";
    }
  },

  watch: {
    originalItem() {
      this.setItemToEdit();
    }
  },

  mounted() {
    this.setItemToEdit();
  },

  methods: {
    ...mapActions(["fetchStockMaterialsList"]),

    setItemToEdit() {
      this.accessoriesOptions = null;
      if (this.editing) {
        this.editedItem = _.cloneDeep(this.originalItem);
      } else {
        this.editedItem = {
          sm_id: null,
          quantity: null
        };
      }
    },

    async loadAccessoriesOptions() {
      if (this.familyId) {
        try {
          let options = [];
          let allOptions = await this.fetchStockMaterialsList({
            material_family_id: this.familyId,
            family_id_others_relation: this.relationFamilyIdSelect
          });
          if (!this.editing) {
            for (let option of allOptions) {
              if (
                !this.selectedFields.find(
                  fieldSelected => fieldSelected.sm_id === option.sm_id
                )
              ) {
                options.push(option);
              }
            }
          } else {
            options = allOptions;
          }
          this.accessoriesOptions = options;
        } catch (e) {
          console.log(e);
        }
      }
    },

    accessoriesOptionsNormalizer(node) {
      return {
        id: node.sm_id,
        label: node.sm_reference
      };
    },

    applyChanges() {
      if (this.requiredAreFilled) {
        if (this.editing) {
          this.$emit("edit", this.editedItem);
        } else {
          let quantity = this.editedItem.quantity;
          this.editedItem = this.accessoriesOptions.find(
            option => option.sm_id === this.editedItem.sm_id
          );
          this.editedItem.quantity = quantity;
          this.$emit("add", this.editedItem);
        }
        this.accessoriesOptions = null;
      }
    },

    close() {
      this.$emit("close");
      this.accessoriesOptions = null;
    },

    updateValue(value) {
      this.editedItem.sm_id = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersForm.vue